Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "NewPost2666399712",
  {"root":"NewPost2666399712--root","avatar":"NewPost2666399712--avatar","placeholder":"NewPost2666399712--placeholder","pluginIcon":"NewPost2666399712--pluginIcon","fillPluginIcon":"NewPost2666399712--fillPluginIcon","strokePluginIcon":"NewPost2666399712--strokePluginIcon"},
  "",
  8,
  "NewPost2666399712"
);

